/* eslint-disable @typescript-eslint/no-empty-function */
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Area, City, Country, PhoneInputConfig, SeoTags } from '../../../base/interfaces/config';

export interface RecruiterAppState {
    initialized: boolean;
    config: Config;
    citySearchOptions: City[] | null;
}
export interface Config {
    countries: Country[];
    areas: Area[];
    phoneInputConfig: PhoneInputConfig;
    seoTags: SeoTags;
}

const phoneInputConfigInitialState = {
    countries: [],
    preferredCountries: [],
    localization: {},
};

const seoTagsInitialState = {
    title: '',
    description: '',
};

const initialState: RecruiterAppState = {
    initialized: false,
    config: {
        countries: [],
        areas: [],
        phoneInputConfig: phoneInputConfigInitialState,
        seoTags: seoTagsInitialState,
    },
    citySearchOptions: null,
};

export const recruiterAppSlice = createSlice({
    name: 'recruiter-app',
    initialState,
    reducers: {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        init: () => {},
        setInitialized: (state, action: PayloadAction<boolean>) => {
            state.initialized = action.payload;
        },
        getConfigSuccess: (state, action: PayloadAction<Config>) => {
            state.config = action.payload;
        },
        sendConfirmationCode: {
            reducer: () => {},
            prepare: (email: string, recaptchaToken: string | null, callback?: () => void) => ({
                payload: { email, recaptchaToken, callback },
            }),
        },
        citySearch: {
            reducer: () => {},
            prepare: (search: string) => ({ payload: search }),
        },
        setCitySearch: (state, action: PayloadAction<City[] | null>) => {
            state.citySearchOptions = action.payload;
        },
    },
});

export const recruiterAppActions = recruiterAppSlice.actions;
export const recruiterAppReducer = recruiterAppSlice.reducer;
